// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  background: var(--html-background-color);
}

body {
  background: var(--background-color);
}

.button {
  border-color: var(--border-button-color) !important;
  background-color: transparent;
}

.button-label {
  color: var(--text-light-color);
}

.theme-button svg path {
  fill: var(--text-light-color);
}

.theme-button:hover,
.holiday-button:hover {
  background-color: var(--border-button-color);
}

.website-button:hover .button-label,
.bento-button:hover .button-label,
.dashboard-button:hover .button-label,
.linkedin-button:hover .button-label,
.twitter-button:hover .button-label,
.bluesky-button:hover .button-label,
.github-button:hover .button-label {
  color: var(--font-theme-color);
}

.email-button:hover .button-label {
  color: #1d1d1d !important;
}

.email-button .button-icon svg path {
  fill: var(--button-default-icon-color) !important;
}

.website-button:hover {
  background-color: #5f59e7;
}

.bento-button:hover {
  background-color: #7a8fff;
}

.bento-button svg .path-0 {
  fill: #dbdbdb;
}

.bento-button svg .path-1 {
  fill: #ff8686;
}

.bento-button svg .path-2 {
  fill: #5aff88;
}

.bento-button svg .path-3 {
  fill: #768cff;
}

.bento-button svg .path-fill {
  fill: #ffffff;
}

.email-button:hover {
  background-color: #f1f1f1;
}

.email-button:hover .button-label {
  color: #1d1d1d !important;
}

.dashboard-button:hover {
  background-color: #000000;
}

.gumroad-button:hover {
  background-color: #ff90e8;
}

.gumroad-button:hover .button-label {
  color: #000000;
}

.gumroad-button:hover svg {
  fill: #ffffff;
}

.gumroad-button svg .path-1 {
  fill: #000000;
}

.gumroad-button svg .path-2 {
  fill: #ff90e8;
  stroke: #000000;
}

.gumroad-button svg .path-3 {
  fill: #000000;
}

.gumroad-button:hover svg .path-1 {
  fill: #000000;
}

.gumroad-button:hover svg .path-2 {
  fill: #ff90e8;
  stroke: #000000;
}

.gumroad-button:hover svg .path-3 {
  fill: #000000;
}

.linkedin-button:hover {
  background-color: #0077b5;
}

.twitter-button:hover {
  background-color: #000000;
}

.bluesky-button .button-icon svg path {
  fill: #0085ff;
}

.bluesky-button:hover {
  background-color: #0085ff;
}

.bluesky-button:hover .button-icon svg path {
  fill: #ffffff;
}

.github-button .button-icon svg path {
  fill: var(--fill-color);
}

.github-button:hover,
.codepen-button:hover {
  background-color: #000000;
}

.github-button:hover .button-icon svg path {
  fill: var(--font-theme-color);
}

.codepen-button .button-icon svg path {
  fill: var(--fill-color);
}

.codepen-button:hover .button-icon svg path {
  fill: var(--font-theme-color);
}

.codepen-button:hover .button-label {
  color: #ffffff;
}

.layers-button svg path {
  fill: var(--text-color);
}

.layers-button:hover svg path {
  fill: #000000;
}

.layers-button:hover {
  background-color: #f1f1f1;
}

.layers-button:hover .button-label {
  color: #252c39;
}

.dribbble-button svg {
  fill: #ffabe7;
}

.dribbble-button:hover svg {
  fill: #ffabe7;
}

.dribbble-button:hover {
  background-color: #ffabe7;
}

.dribbble-button:hover .button-label {
  color: #5e0043;
}

.badge.circle .pulse-element,
.badge.rectangle {
  background-color: var(--accent-color);
}

.badge.circle {
  background-color: rgba(31, 210, 72, 50%);
}

.badge-text {
  color: var(--font-theme-color);
}

.card {
  border-color: var(--border-color) !important;
  background-color: var(--card-background-color);
}

[data-theme="dark"] .background-manager {
  opacity: 0.04;
}

h1,
h2,
p,
.logo-text {
  color: var(--text-color);
}

.logo-sub-text {
  color: var(--text-light-color);
}

.tooltip {
  background-color: var(--primary-color);
  color: var(--tooltip-theme-color);
}

footer {
  color: var(--text-light-color);
}

.stamp-svg svg path,
.mobile-stamp svg path {
  fill: var(--primary-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/theme.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mDAAmD;EACnD,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;;;;;;EAOE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,0BAA0B;AAC5B","sourcesContent":["html {\n  background: var(--html-background-color);\n}\n\nbody {\n  background: var(--background-color);\n}\n\n.button {\n  border-color: var(--border-button-color) !important;\n  background-color: transparent;\n}\n\n.button-label {\n  color: var(--text-light-color);\n}\n\n.theme-button svg path {\n  fill: var(--text-light-color);\n}\n\n.theme-button:hover,\n.holiday-button:hover {\n  background-color: var(--border-button-color);\n}\n\n.website-button:hover .button-label,\n.bento-button:hover .button-label,\n.dashboard-button:hover .button-label,\n.linkedin-button:hover .button-label,\n.twitter-button:hover .button-label,\n.bluesky-button:hover .button-label,\n.github-button:hover .button-label {\n  color: var(--font-theme-color);\n}\n\n.email-button:hover .button-label {\n  color: #1d1d1d !important;\n}\n\n.email-button .button-icon svg path {\n  fill: var(--button-default-icon-color) !important;\n}\n\n.website-button:hover {\n  background-color: #5f59e7;\n}\n\n.bento-button:hover {\n  background-color: #7a8fff;\n}\n\n.bento-button svg .path-0 {\n  fill: #dbdbdb;\n}\n\n.bento-button svg .path-1 {\n  fill: #ff8686;\n}\n\n.bento-button svg .path-2 {\n  fill: #5aff88;\n}\n\n.bento-button svg .path-3 {\n  fill: #768cff;\n}\n\n.bento-button svg .path-fill {\n  fill: #ffffff;\n}\n\n.email-button:hover {\n  background-color: #f1f1f1;\n}\n\n.email-button:hover .button-label {\n  color: #1d1d1d !important;\n}\n\n.dashboard-button:hover {\n  background-color: #000000;\n}\n\n.gumroad-button:hover {\n  background-color: #ff90e8;\n}\n\n.gumroad-button:hover .button-label {\n  color: #000000;\n}\n\n.gumroad-button:hover svg {\n  fill: #ffffff;\n}\n\n.gumroad-button svg .path-1 {\n  fill: #000000;\n}\n\n.gumroad-button svg .path-2 {\n  fill: #ff90e8;\n  stroke: #000000;\n}\n\n.gumroad-button svg .path-3 {\n  fill: #000000;\n}\n\n.gumroad-button:hover svg .path-1 {\n  fill: #000000;\n}\n\n.gumroad-button:hover svg .path-2 {\n  fill: #ff90e8;\n  stroke: #000000;\n}\n\n.gumroad-button:hover svg .path-3 {\n  fill: #000000;\n}\n\n.linkedin-button:hover {\n  background-color: #0077b5;\n}\n\n.twitter-button:hover {\n  background-color: #000000;\n}\n\n.bluesky-button .button-icon svg path {\n  fill: #0085ff;\n}\n\n.bluesky-button:hover {\n  background-color: #0085ff;\n}\n\n.bluesky-button:hover .button-icon svg path {\n  fill: #ffffff;\n}\n\n.github-button .button-icon svg path {\n  fill: var(--fill-color);\n}\n\n.github-button:hover,\n.codepen-button:hover {\n  background-color: #000000;\n}\n\n.github-button:hover .button-icon svg path {\n  fill: var(--font-theme-color);\n}\n\n.codepen-button .button-icon svg path {\n  fill: var(--fill-color);\n}\n\n.codepen-button:hover .button-icon svg path {\n  fill: var(--font-theme-color);\n}\n\n.codepen-button:hover .button-label {\n  color: #ffffff;\n}\n\n.layers-button svg path {\n  fill: var(--text-color);\n}\n\n.layers-button:hover svg path {\n  fill: #000000;\n}\n\n.layers-button:hover {\n  background-color: #f1f1f1;\n}\n\n.layers-button:hover .button-label {\n  color: #252c39;\n}\n\n.dribbble-button svg {\n  fill: #ffabe7;\n}\n\n.dribbble-button:hover svg {\n  fill: #ffabe7;\n}\n\n.dribbble-button:hover {\n  background-color: #ffabe7;\n}\n\n.dribbble-button:hover .button-label {\n  color: #5e0043;\n}\n\n.badge.circle .pulse-element,\n.badge.rectangle {\n  background-color: var(--accent-color);\n}\n\n.badge.circle {\n  background-color: rgba(31, 210, 72, 50%);\n}\n\n.badge-text {\n  color: var(--font-theme-color);\n}\n\n.card {\n  border-color: var(--border-color) !important;\n  background-color: var(--card-background-color);\n}\n\n[data-theme=\"dark\"] .background-manager {\n  opacity: 0.04;\n}\n\nh1,\nh2,\np,\n.logo-text {\n  color: var(--text-color);\n}\n\n.logo-sub-text {\n  color: var(--text-light-color);\n}\n\n.tooltip {\n  background-color: var(--primary-color);\n  color: var(--tooltip-theme-color);\n}\n\nfooter {\n  color: var(--text-light-color);\n}\n\n.stamp-svg svg path,\n.mobile-stamp svg path {\n  fill: var(--primary-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
